<template>
  <div>
    <div v-show="panel !== '4'">
      <modals-container name="modal1" />
      <v-dialog/>
      <div class="admin_title">组织架构</div>
      <!--左侧内容-->
      <div class="col_2_1 w240">
        <el-tabs v-model="activeName" type="card" :stretch="true">
          <el-tab-pane label="树形菜单" name="first">
            <div v-if="!asyncFlag" style="padding-top: 48px; text-align: center;">
              <xo-loader :type="'cube'" :color="['#ff3634']" :size="{width: '32px', height: '32px'}" :font="{fontSize: '12px'}" :text="'载入组织架构中...'"></xo-loader>
            </div>
            <div v-if="asyncFlag && options.boxStyle.width">
              <TreeView v-if="treemenu && treemenu.length > 0" :model="treemenu" @node-clicked="nodeClicked" :options="options"></TreeView>
              <div class="col_2_1 w240" v-else>
                <img src="@/assets/images/none_data.jpg">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="自定义搜索" name="second">
            <CustomSearch @node-clicked="nodeClicked"></CustomSearch>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!--/左侧内容-->
      <!--右侧内容-->
      <div class="col_2_2 w705 gj_right structure_org_stretch" v-show="panel == '0'">
        <div class="top_gj_r" v-if="paginationType == '0'">
          <label style="margin-right: 5px;" v-if="dept && dept.name">
            {{dept.name}}
          </label>
          <label v-if="!dept.name">请在左侧菜单中选择部门</label>
          <span v-for="item in itemTags.lists" :key="item.id" style="position: relative; margin-right: 5px; width: 24px; height: 24px; vertical-align: middle">
            <img v-if="item.style" :src="item.style" width="24" height="24" style="vertical-align: middle;">
            <span v-if="!item.style" style="border: 1px solid #ff3633; position: relative; right: 0;">{{item.content}}</span>
          </span>
          <span>
            <a @click="switchPanel('2');formdept = {};" style="cursor: pointer;">新增部门</a> |&nbsp;&nbsp;
            <el-dropdown>
              <span class="el-dropdown-link" style="position: relative; cursor: pointer">
                导入功能<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><span @click="importOrgs()">导入组织架构</span></el-dropdown-item>
                <el-dropdown-item><a :href="downloadLink1">下载组织架构模板</a></el-dropdown-item>
                <el-dropdown-item><a :href="downloadLink">下载成员模板</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
        <div class="top_gj_r" v-if="paginationType == '1'">
          <label>当前处在模糊查询状态</label>
          <span>
            <a @click="switchPanel('2');formdept = {};" style="cursor: pointer;">新增部门</a> |&nbsp;&nbsp;
            <el-dropdown>
              <span class="el-dropdown-link" style="position: relative; cursor: pointer">
                导入功能<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><span @click="importOrgs()">导入组织架构</span></el-dropdown-item>
                <el-dropdown-item><a :href="downloadLink1">下载组织架构模板</a></el-dropdown-item>
                <el-dropdown-item><a :href="downloadLink">下载成员模板</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
        <div class="gj_top_class">
          <input name="" type="button" class="btn_s_gj" @click="clickToFuzzySearch(filters1)" />
          <input name="" type="text" class="put_gj"  v-model="filters1.search" @keyup.13="clickToFuzzySearch(filters1)" placeholder="输入姓名、标签、手机号等" />
        </div>
        <div class="top_gj_btn">
          <a @click="switchPanel('1');setPersonForm()">新增成员</a>
          <!--a @click="createUsers(selected)">批量生成用户</a-->
          <a @click="delUsers(selected)">批量删除</a>
          <!--a @click="switchPanel('4')">批量打标签</a-->
          <a @click="importUsers()">导入成员</a>
        </div>
        <div v-if="panel == '0'" style="min-height: 620px;">
          <el-table v-if="tableData.data && tableData.data.length > 0"
                    :data="tableData.data" stripe border @selection-change="updateSelected"
                    style="width: 100%">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="120"></el-table-column>
            <el-table-column prop="email" label="邮箱" width="250"></el-table-column>
            <el-table-column prop="mobile" label="手机" width="120"></el-table-column>
            <el-table-column prop="idCard" label="身份证" width="180"></el-table-column>
            <!--<el-table-column label="标签" width="60">
              <template slot-scope="scope">
                <div v-if="scope.row.tagInfos && scope.row.tagInfos.length > 0">
                   <a :title="scope.row.tagInfos[0].content" style="position: relative; width: 24px; height: 24px; vertical-align: middle">
                      <img v-if="scope.row.tagInfos[0].style" :src="scope.row.tagInfos[0].style" width="24" height="24" style="vertical-align: middle;">
                      <span v-if="!scope.row.tagInfos[0].style" style="border: 1px solid #ff3633; color: #ff3633;">{{scope.row.tagInfos[0].content}}</span>
                    </a>
                </div>
              </template>
            </el-table-column>-->
            <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <a class="el-icon-edit" @click="edit(scope.row)" title="编辑" style="cursor: pointer;"></a>
                <a class="el-icon-delete" @click="del(scope.row)" title="删除" style="cursor: pointer;"></a>
                <a class="el-icon-my-tag" @click="addtag(scope.row)" title="人员标签" style="cursor: pointer;"></a>
                <a v-if="!scope.row.memberUsers" class="el-icon-my-admin" @click="createUser(scope.row)" title="生成用户" style="cursor: pointer;"></a>
              </template>
            </el-table-column>
          </el-table>
          <h5 class="none_ts" v-if="tableData.data.length == 0">
            <img src="@/assets/images/none_data.jpg" alt="">
          </h5>
        </div>
        <div class="zy_list_bottom mtf30" v-show="paginationType=='0'">
          <dl>
            <dt v-if="pages > 0">共{{cnt}}个人员</dt>
            <dd>
              <paginate ref="paginate" v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                        :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                        :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                        :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                        :first-last-button=$global.paginationOptions.first_last_button
                        :active-class=$global.paginationOptions.active_class
                        :disabled-class=$global.paginationOptions.disabled_class
                        :first-button-text=$global.paginationOptions.first_button_text
                        :last-button-text=$global.paginationOptions.last_button_text
                        :prev-text=$global.paginationOptions.prev_text
                        :next-text=$global.paginationOptions.next_text></paginate>
            </dd>
          </dl>
        </div>
        <div class="zy_list_bottom mtf30" v-show="paginationType=='1'">
          <dl>
            <dt v-if="pages1 > 0">共{{cnt1}}个人员</dt>
            <dd>
              <paginate ref="paginate1" v-if="pages1 > 0" :click-handler="clickCallback1" :page-count=pages1
                        :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                        :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                        :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                        :first-last-button=$global.paginationOptions.first_last_button
                        :active-class=$global.paginationOptions.active_class
                        :disabled-class=$global.paginationOptions.disabled_class
                        :first-button-text=$global.paginationOptions.first_button_text
                        :last-button-text=$global.paginationOptions.last_button_text
                        :prev-text=$global.paginationOptions.prev_text
                        :next-text=$global.paginationOptions.next_text></paginate>
            </dd>
          </dl>
        </div>
      </div>
      <div class="col_2_2 w705 gj_right structure_org_stretch" v-show="panel == '1'">
        <div class="add_man_tit"><span v-if="JSON.stringify(formperson) == '{}'">新增</span><span v-else>编辑</span>人员</div>
        <div class="add_con_man">
          <Person @saved="getDataPF" @closed="panel = '0'" :data="formperson"></Person>
        </div>
      </div>
      <div class="col_2_2 w705 gj_right structure_org_stretch" v-show="panel == '2'">
        <div class="add_man_tit"><span v-if="JSON.stringify(formdept) == '{}'">新增</span><span v-else>编辑</span>部门</div>
        <div class="add_con_man">
          <Dept @saved="getDataFF" @closed="panel = '0'" :data="formdept"></Dept>
        </div>
      </div>
      <div class="col_2_2 w705 gj_right structure_org_stretch" v-show="panel == '3'">
        <div class="add_man_tit">
          <label>{{currentTagObject.name}}</label>
          <a v-for="item in itemTags.lists" :key="item.id" style="position: relative; margin-right: 5px; width: 24px; height: 24px; vertical-align: middle">
            <img v-if="item.style" :src="item.style" width="24" height="24" style="vertical-align: middle;">
            <span v-if="!item.style" style="border: 1px solid #ff3633; color: #ff3633; position: relative; right: 0;">{{item.content}}</span>
          </a>
        </div>
        <div class="add_con_man">
          <TagEdit @closed="tagPanelClosed" @saved="tagSaved" @userTagsUpdated="userTagsUpdated" :params="itemTags"></TagEdit>
        </div>
      </div>
      <!--/右侧内容-->
      <div class="clear"></div>
    </div>
    <div v-show="panel == '4'">
      <div class="admin_title">组织架构</div>
      <div class="col_2_1 w945 gj_right">
        <TagPickerWithTree :params="currentComponent"></TagPickerWithTree>
        <div class="add_bt_foot">
          <input name="" type="button" value="保存" />
          <input name="" class="hui_color" type="button" value="取消" @click="panel = '0'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/index'
import config from '@/config/index'
import TreeSelect from '@/page/byl/sys/menu/treemenu.vue'
import CustomSearch from '@/page/byl/org/structure/customsearch/index'
import ModalBox from '@/components/common/modal/index.vue'
import InfoBox from '@/components/byl/InfoBox/noEdit.vue'
import TagEdit from '@/page/byl/org/structure/tag.vue'
import TagPickerWithTree from '@/components/byl/tagPicker/withTree.vue'
import TreeView  from '@/components/common/treeview/index.vue'
import Dept from '@/page/byl/org/structure/dept.vue'
import Person from '@/page/byl/org/structure/person.vue'
import Paginate from 'vuejs-paginate'
import utils from '@/utils'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  components: { TreeView, CustomSearch, Dept, Person, Paginate, TagEdit, TagPickerWithTree },
  data () {
    var that = this
    return {
      downloadLink: config.employee_sheets, // 成员模板
      downloadLink1: config.org_sheets, // 机构模板
      asyncFlag: false,
      activeName: 'first',
      menusWidth: '',
      itemTags: {
        lists: []
      },
      pages: 0,
      pages1: 0,
      filters: {
        pageNo: 1,
        pageSize: 9
      },
      filters1: {
        pageNo: 1,
        pageSize: 9,
        search: ''
      },
      currentComponent: {
        name: 'range',
        template: TagPickerWithTree,
        outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
        inputs: [] // 向组件内传入的数据, 一般用于初始化
      },
      currentTagType: '', // '01': '人员' 02: '部门'
      currentTagObject: '', // 当前部门/人员
      options: {
        parentNodeClickable: true, //  点击有子菜单的node是否可以发出事件
        multiselect: false, // 是否允许多选
        searchMode: true, // 是否提供前端过滤
        editMode: true,
        semiCheck: false, // 是否提供全选（选中父级则勾选中所有子级）
        hasScroll: true,
        boxStyle: {
          // width: that.menusWidth,
          height: '600px'
        },
        del: function (val) {
          that.confirmBox({
            title: '删除',
            text: '确认删除' + val.name + '吗?',
            yes: function () {
              that.$modal.hide('dialog')
              that.delDept(val.id)
            }
          })
        },
        edit: function (val) { // 编辑部门
          that.panel = '2'
          api.get(config.bylApiPath, '/dep/' + val.id, null, function (r) {
            that.formdept = r.data
          })
        },
        addtag: function (val) { // 给部门打标签
          that.panel = '3'
          // val.type = '02'
          that.currentTagType = '02'
          that.currentTagObject = val
        }
      },
      tableData: {
        columns: [
          {
            field: 'name',
            title: '姓名',
            colWidth: 82
          }, {
            field: 'post',
            title: '职务',
            colWidth: 122
          }, {
            field: 'idCard',
            title: '身份证号',
            colWidth: 150
          }
        ],
        data: [],
        actions: ['edit', 'del', 'tag', 'createUser', 'createUserAlready'] // slot插槽命名
      },
      cnt: 0,
      cnt1: 0,
      treemenu: [],
      formperson: {},
      formdept: {},
      panel: '0', // '0': 列表; '1': 添加成员; '2': 添加部门
      selected: [], // 选择的列表
      createUserType: '1', // 创建用户账号类型
      paginationType: '0' // '0'：正常分页， '1': 模糊查询后的分页
    }
  },
  created () {
    this.clearPeople() // 清空人员的缓存
    this.initData()
    if (this.list && this.list.length > 0) {
      this.tableData.data = this.list
    }
  },
  mounted () {
  },
  watch: {
    panel (val) {
      if (val == '3') {
        this.getTags(this.currentTagObject.id)
      }
    },
    itemTags: {
      handler (newVal, oldVal) {
        for (let i = 0; i < newVal.lists.length; i++) {
          let o = newVal.lists[i]
          o.id = o.tagId
        }
        newVal.type = this.currentTagType
        newVal.currentTagObject = this.currentTagObject
        this.itemTags = newVal
      },
      deep: true
    },
    currentTagObject (val) {
      this.getTags(this.currentTagObject.id)
    },
    getCurrentDepts (val) { // 异步获取到的所有部门数据需要用watch
      this.treemenu = val
      this.asyncFlag = true
      // this.$set(this, 'treemenu', val) // 对象新增属性需要这么写
    },
    getCurrentList (val) { // 异步获取到的所有部门下面的人员数据需要用watch
      this.tableData.data = val
    },
    getDimension (val) {
      // this.options.boxStyle.width = val.menusWidth
      this.options.boxStyle.width = 225
      this.options.depth = val.depth
    }
  },
  computed: {
    ...mapState('orgstructure', ['menus', 'dept', 'list']),
    ...mapGetters('orgstructure', ['getCurrentList', 'getCurrentDepts', 'getCurrentDept', 'getDimension'])
  },
  methods: {
    ...mapActions('orgstructure', ['getDepts', 'addDept', 'delDept', 'getPersonByDept', 'setDept', 'addPerson', 'clearPeople']),
    updateSelected (val) {
      this.selected = val
    },
    clickCallback (pageNum)  { // 正常分页切换
      this.filters.pageNo = pageNum
      this.getPersonBy({id: this.dept.id, pageNo: this.filters.pageNo, pageSize: this.filters.pageSize})
    },
    clickCallback1 (pageNum) { //  模糊查询分页切换
      this.filters1.pageNo = pageNum
      this.fuzzySearch(this.filters1)
    },
    switchPanel (panel) {
      this.panel = panel;
      this.$modal.hide();
    },
    setPersonForm () {
      this.formperson = {
        parent: this.dept
      }
    },
    edit (item) {
      var that = this
      this.panel = '1'
      api.get(config.bylApiPath, '/member/' + item.id, null, function (r) {
        that.formperson = r.data
      })
    },
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: o.title,
        text: o.text,
        buttons: [
          {
            title: '确认',
            default: true,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    delUsers (items) {
      if (items.length > 0) {
        var that = this
        this.confirmBox({
          title: '删除',
          text: '确认删除吗?',
          yes: function () {
            var ids = utils.arr2str(utils.grabVal(items, 'id'))
            api.get(config.bylApiPath, '/member/delete/batch', {ids: ids}, function (r) { // 正常
              that.$toasted.show('删除成功')
              setTimeout(function () {
                that.getPersonBy({ id: that.getCurrentDept.id, pageNo: that.filters.pageNo, pageSize: that.filters.pageSize })
              }, 0)
              that.$modal.hide('dialog')
            })
          }
        })
      } else {
        this.$toasted.show('没有删除项')
      }
    },
    createUsers (items) {
      // console.log(items)
    },
    importUsers () {
      var that = this
      this.confirmBox({
        title: '导入成员',
        text: '<input id="importUsers" type="file">',
        yes: function () {
          var file = document.getElementById('importUsers').files;
          if (file.length) {
            var isExcel = /\.(?:xls|xlsx)$/i.test(file[0].name);
            if (isExcel) {
              var o = {}
              o.file = file[0]
              var fd = new FormData()
              for (var key in o) {
                fd.append(key, o[key])
              }
              api.post(config.bylApiPath, '/member/importMember', fd, function (r) { // 正常
                that.$toasted.show(r.data)
                setTimeout(function () {
                  that.initData()
                }, 0)
                that.$modal.hide('dialog')
              })
            } else {
              that.$toasted.show('只允许上传.xsl,.xslx格式的文件')
            }
          } else {
            that.$toasted.show('请选择文件')
          }
        }
      })
    },
    importOrgs () {
      var that = this
      this.confirmBox({
        title: '导入机构',
        text: '<input id="importOrgs" type="file">',
        yes: function () {
          var file = document.getElementById('importOrgs').files;
          if (file.length) {
            var isExcel = /\.(?:xls|xlsx)$/i.test(file[0].name);
            if (isExcel) {
              var o = {}
              o.file = file[0]
              var fd = new FormData()
              for (var key in o) {
                fd.append(key, o[key])
              }
              api.post(config.bylApiPath, '/dep/importDep', fd, function (r) { // 正常
                that.$toasted.show(r.data)
                setTimeout(function () {
                  that.initData()
                }, 0)
                that.$modal.hide('dialog')
              })
            } else {
              that.$toasted.show('只允许上传.xsl,.xslx格式的文件')
            }
          } else {
            that.$toasted.show('请选择文件')
          }
        }
      })
    },
    createUser (item) {
      if (item) {
        var that = this
        this.confirmBox({
          title: '生成用户',
          text: '请选择账号类型: <select id="createUserType" class="all_select"><option value="1">手机号</option><option value="2">邮箱</option></select>',
          yes: function () {
            var o = {
              accountType: $('#createUserType').val(),
              memberId: item.id
            }
            api.post(config.bylApiPath, '/member/batch/create/user', {registerList: [o]}, function (r) { // 正常
              that.$toasted.show('创建账户成功')
              setTimeout(function () {
                that.getPersonBy({ id: that.getCurrentDept.id, pageNo: that.filters.pageNo, pageSize: that.filters.pageSize })
              }, 0)
              that.$modal.hide('dialog')
            })
          }
        })
      }
    },
    del (item) {
      if (item) {
        var that = this
        this.confirmBox({
          title: '删除',
          text: '确认删除吗?',
          yes: function () {
            api.get(config.bylApiPath, '/member/delete/batch', {ids: item.id}, function (r) { // 正常
              that.$toasted.show('删除成功')
              setTimeout(function () {
                that.getPersonBy({ id: that.getCurrentDept.id, pageNo: that.filters.pageNo, pageSize: that.filters.pageSize })
              }, 0)
              that.$modal.hide('dialog')
            })
          }
        })
      }
    },
    nodeClicked (node) { // 获取部门下面的人员
      this.setDept(node)
      this.getPersonBy({ id: node.id, pageNo: this.filters.pageNo, pageSize: this.filters.pageSize })
      this.panel = '0'
      this.currentTagObject = node
      this.paginationType = '0' // 切换成正常按部门查询状态
      if (this.$refs.paginate) {
        this.$refs.paginate.selected = 0
      }
      if (this.$refs.paginate1) {
        this.$refs.paginate1.selected = 0
      }
    },
    getPersonBy (dept) {
      this.getPersonByDept(dept).then((r) => {
        this.cnt = r.cntData
        this.pages = r.cntPage
        if (this.$refs.paginate) {
          this.$refs.paginate.selected = this.filters.pageNo - 1
        }
      })
    },
    getDataFF (data) { // 新增/编辑部门（和Dept模块的交互）
      var that = this
      if (data.parent) { delete data.parent }
      if (data.newparent) { delete data.newparent }
      this.addDept(data)
      setTimeout(function () {
        that.initData()
      }, 1000)
    },
    getDataPF (data) { // 新增/编辑人员/分页更新（和Person模块的交互）
      var that = this
      if (data) { // 有data表示保存
        var deptId = data.parent.id
        if (data.parent) { delete data.parent }
        this.addPerson(data)
      }
      if (this.paginationType == '0') { // 正常按部门查询状态
        // setTimeout(function () {
          that.getPersonBy({ id: that.dept.id, pageNo: that.filters.pageNo, pageSize: that.filters.pageSize })
        // }, 1000)
      } else { // 模糊查询状态
        that.fuzzySearch(that.filters1)
      }
    },
    userTagsUpdated (data) {
      // console.log(this.currentTagObject)
      // this.itemTags.lists = data
      // this.getTags(this.currentTagObject.id)
      this.itemTags.lists = $.extend(true, [], data)
    },
    initData (dept) {
      this.getDepts(dept).then((r) => { // 异步获取部门信息 之后会默认去取部门下的人员
        this.asyncFlag = true
        if (r) {
          var did;
          if (dept && dept.id) {
            did = dept.id
          } else {
            did = r[0].id
          }
          this.getPersonBy({ id: did, pageNo: this.filters.pageNo, pageSize: this.filters.pageSize })
          this.getTags(did)
        }
      })
    },
    clickToFuzzySearch (filters) {
      if (this.$refs.paginate1) {
        this.$refs.paginate1.selected = 0
      }
      filters.pageNo = 1
      this.fuzzySearch(filters)
    },
    fuzzySearch (filters) {
      this.paginationType = '1' // 切换成模糊查询状态
      let f = {
        pageNo: filters.pageNo,
        pageSize: filters.pageSize
      }
      if (filters.search) {
        f.search =  '%' + filters.search + '%'
      }
      api.post(config.bylApiPath, '/member/members/list', f, (r) => { // 正常
        if (r.data) {
          this.tableData.data = r.data
          this.cnt1 = r.cntData
          this.pages1 = r.cntPage
        } else {
          this.tableData.data = []
          this.cnt1 = 0
          this.pages1 = 0
        }
        if (this.$refs.paginate1) {
          this.$refs.paginate1.selected = this.filters1.pageNo - 1
        }
      })
    },
    addTagPickerWithTree () {
      var that = this
      this.$modal.show(ModalBox, {
        opts: {
          title: '打标签',
          styles: {
            width: '960',
            height: String(0.8242 * window.screen.availHeight)
          },
          currentComponent: {
            name: 'range',
            template: TagPickerWithTree,
            outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
            inputs: [] // 向组件内传入的数据, 一般用于初始化
          },
          yes (val) { // 点击确认后要做的事情
          },
          closed () { // 这里要判断, 只有新增状态下需要清空
            console.log('closed')
            that.$modal.hide('modal32')
          }
        }
      })
    },
    addtag (val) { // 给人员打标签
      this.panel = '3'
      this.currentTagType = '01'
      this.currentTagObject = val
    },
    getTags (id) { // 获取该部门/人员对应的标签列表
      api.get(config.tagApiPath, '/teamTag/findList', {itemId: id, pageNo: '1', pageSize: '100'}, (r) => { // 正常
        if (r.data) {
          this.itemTags.lists = r.data
        } else {
          this.itemTags.lists = []
        }
      })
    },
    tagPanelClosed () { // 和TagEdit模块的交互
      this.panel = '0'
      // this.paginationType = '0' // 切换成正常按部门查询状态, 需求变动后可以去掉这一行
      if (this.paginationType == '0') { // 正常按部门查询状态
        this.initData(this.dept)
      } else { // 模糊查询状态
        this.fuzzySearch(this.filters1)
      }
    },
    tagSaved (val) { // 主要是刷新数据
      var that = this
    },
    getMemberById (id) {
      return new Promise(function (resolve, reject) {
        api.get(config.bylApiPath, '/member/' + id, {}, r => {
          resolve(r.data)
        })
      })
    },
    showInfo (item) {
      var that = this
      var d = []
      this.getMemberById(item.id).then((r) => {
        if (r) {
          d = [r]
        }
        this.$modal.show(ModalBox, {
          opts: {
            title: '用户信息',
            styles: {
              width: '670',
              height: String(0.6181 * window.screen.availHeight)
            },
            offEdit: true,
            currentComponent: {
              name: 'infobox',
              template: InfoBox,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                data: d
              } // 向组件内传入的数据, 一般用于初始化
            }
          }
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/structure/index.vue